import React from 'react';
import Header from 'component/Header';
import About from 'component/About';
import Feature from 'component/Feature';
import Testinomial from 'component/Testinomail';
// background-color:#f4f5ff; 
const Homepage = () => {
    return (
        <>
       <Header />
       <About />
       <Feature />
       <Testinomial />
        </>
    )
}

export default Homepage;